// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeleteButton_delete-btn__homzR {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  background-color: var(--gray-light);
  display: flex;
  justify-content: center;
  align-items: center;
}

.DeleteButton_delete-btn__img__dzldh {
  width: 50%;
  height: 50%;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/DeleteButton/DeleteButton.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".delete-btn {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 50%;\n  background-color: var(--gray-light);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.delete-btn__img {\n  width: 50%;\n  height: 50%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"delete-btn": `DeleteButton_delete-btn__homzR`,
	"delete-btn__img": `DeleteButton_delete-btn__img__dzldh`
};
export default ___CSS_LOADER_EXPORT___;
